// How the scaling works:
// love scores are integers [-2;5]
// our slider returns 0-100, where lower number corresponds to higher score
// we also want to make sure that 0 is the mid-point of the slider (50)
// which means the lower half will be more coarse
export var valueRange = 100;
export var midPoint = valueRange / 2;
var negativeScaleFactor = 2 / midPoint;
var positiveScaleFactor = 5 / midPoint;
export function getLoveScoreFromPoints(value) {
    var shiftedValue = valueRange - value - midPoint;
    // at this point 0 points = 0 on the scale, and signs match
    if (shiftedValue < 0) {
        return Math.round(shiftedValue * negativeScaleFactor);
    }
    return Math.round(shiftedValue * positiveScaleFactor);
}
export function getPointsFromLoveScore(score) {
    // first, re-scale to [-50,50]
    var scaledValue = Math.round(score < 0 ? score / negativeScaleFactor : score / positiveScaleFactor);
    return 100 - (scaledValue + midPoint);
}
export function isLove(value) {
    return value < midPoint;
}
export function isHate(value) {
    return value > midPoint;
}
export function loveScoreToHintLevel(value) {
    if (typeof value === 'undefined') {
        return 'neutral';
    }
    var score = getLoveScoreFromPoints(value);
    if (score < 0) {
        return 'hate';
    }
    if (score === 0) {
        return 'neutral';
    }
    if (score < 5) {
        return 'like';
    }
    return 'love';
}
//# sourceMappingURL=scales.js.map